var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:_vm.columnCls,style:(_vm._headerStyles),attrs:{"role":"columnheader"}},[_c('div',{staticClass:"md-grid-th-inner"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }